import { API_BASE_URL, apiRequest } from './httpClient';

// Frontend dropdowns are generated from this response - never hardcode a
// provider list in a component.
export function getProviders() {
  return apiRequest('/api/speech/providers');
}

// Not built on apiRequest: the TTS endpoint returns an audio blob, not
// JSON, so this mirrors apiRequest's fetch/credentials conventions but
// resolves to a Blob instead.
export async function synthesizeAnswer({ meetingId, aiResponseId }) {
  const response = await fetch(`${API_BASE_URL}/api/speech/tts`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      meeting_id: meetingId,
      ai_response_id: aiResponseId,
    }),
  });

  if (!response.ok) {
    let message = `Request failed with status ${response.status}`;

    try {
      const data = await response.json();
      if (data && data.detail) message = data.detail;
    } catch (_) {
      // No JSON body.
    }

    throw new Error(message);
  }

  return response.blob();
}
